import React, { Component } from 'react';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

import moment from 'moment'
import 'moment/locale/es'  
import { Button } from '@material-ui/core';
// Component styles
import styles from '../styles';
moment.locale('es')

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  
  render() {
    const { classes  } = this.props;
    return (
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              xl={12}
              className={classes.alignLeft}
            >
              <Typography  className={classes.textGrey} variant="h3">Información</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              xl={12}
              className={classes.alignLeft}
            >
              <Typography className={classes.textGrey} variant="h6">Plataforma para crear template ingrese nombre,  </Typography>
              <Typography className={classes.textGrey} variant="h6">descripcion, icono y formato de template</Typography>
            </Grid>
          </Grid>
             
    )
  }
}

export default withStyles(styles)(Info);
